interface FieldLabelProps {
  htmlFor?: string;
  required?: boolean;
  children: React.ReactNode;
}

export const FieldLabel = ({
  htmlFor,
  required,
  children,
}: FieldLabelProps) => (
  <label
    htmlFor={htmlFor}
    className="block text-xs font-medium text-gray-700 uppercase tracking-wide"
  >
    {children}
    {required && (
      <span className="text-red-500 ml-0.5 text-xs" aria-label="Required">
        *
      </span>
    )}
  </label>
);
